import React, {useState} from "react";
import Spinner from "react-bootstrap/Spinner";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SweetAlert from 'react-bootstrap-sweetalert'
import CustomButton from "components/CustomButtons/Button";
import Button from 'react-bootstrap/Button'
import {apiRequest} from 'util/api/util'
import { useSelector, useDispatch } from 'react-redux';
import { cancelReservation } from "store/actions/dashboardActions";

function CancelReservationButton({reservationId, reservationData, onCancel}) {

    const currency = useSelector(state => state.instructor.instructor?.instructorProfile?.currency ?? "USD")
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });

    const [alert, setAlert] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const [disableModal, setDisableModal] = useState(false)

    const dispatch = useDispatch()

    const cancelSingleReservation = (issueRefund) => {
        setIsLoading(true)

        console.log("CANCELING: ", issueRefund)

        dispatch(cancelReservation(reservationId, issueRefund))
            .then(val => {
                setIsLoading(false)
            })
            .catch(err => {
                setIsLoading(false)
            })
    }

    const noRefundButton = () => {
        // return "Remove • no refund"

        if (reservationData.reservationType === 'subscription') {
            return null
        }

        return (
            <Button disabled={disableModal} onClick={() => cancelSingleReservation(false)} className="mr-1" variant='outline-danger'>Remove • no refund</Button>
        )
    }

    const refundButton = () => {

        let buttonText = ""

        if (reservationData.reservationType === 'subscription') {
            buttonText = "Remove & credit package"
        } else if (reservationData.reservationType === 'pack') {
            buttonText = "Remove & credit package"
        } else if (reservationData.reservationType === 'drop in') {
            const payment = currencyFormatter.format(reservationData.payment ?? 0)
            buttonText = "Remove & refund " + payment
        } else {
            return null
        }



        return (
            <Button disabled={disableModal} onClick={() => {
                console.log("Removing student reservation")
                cancelSingleReservation(true)
            }} variant='outline-danger'>{buttonText}</Button>
        )
    }

    const handleClick = (e) => {
        e.preventDefault()
        
        setAlert(<SweetAlert
            
            style={{marginTop: "100px"}}
            title="Remove student"
            showCloseButton={disableModal ? false : true}
            closeOnClickOutside={disableModal ? false : true}

            onCancel={() => {
                console.log("Handle cancel")
                setAlert(false)
            }}

            onConfirm={() => {
                console.log("confirmed")
            }}
            customButtons={<div>
                {noRefundButton()}
                {refundButton()}
            </div>}

          >
            Are you sure you'd like to remove this student?
            
            {isLoading && (
                <Spinner
                animation="border"
                size="sm"
                role="status"
                aria-hidden={true}
                className="ml-2"
                >
                </Spinner>
            )}
          </SweetAlert>)
    }
    return (<>
        {alert}

        <CustomButton
        justIcon
        simple
        onClick={handleClick}
        color="danger"
        >
            <DeleteForeverIcon />
        </CustomButton>
    </>)
}

export default CancelReservationButton